<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CRow>
        <CCol col="12">
          <CardImageLandScape :cardContent="content" @funcRoute="funcRoute" />
        </CCol>
      </CRow>
    </template>
  </div>
</template>

<script>
import '../../../assets/scss/_chineseStyle.scss';
import CardImageLandScape from './components/CardImageLandScape.vue';
import {mapGetters} from 'vuex';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {CardImageLandScape, LoadingMDL},
  name: 'CTA01',
  data() {
    return {
      content: {},
      lang: '',
      baseUrl: process.env.VUE_APP_URL_SOUND,
      CheckWidth: window.innerWidth.toString(),
      courseCode: '',
      topicId: '',
      loaded: false,
      userTemplateData: [],
      nextAction: [],
      courseSection: '',
      startTime: '',
      condition: [],
      loading: true,
      v3Data: {},
    };
  },

  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      storeLanguage: 'language/getLanguage',
      courseTopicID: 'courses/getCourseTopicID',
      // getUserTemplate: 'template/getUserTemplate',
      // loadingGetter: 'template/loadingGetter',
      getTemplatev3: 'v3/getTemplates',
    }),
  },

  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      this.content = val.templates[0];

      if (!this.content.enable) {
        const pathFormat = this.content.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }
      // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

      this.loading = false;
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
  },

  mounted() {},

  created() {
    this.onLoad();
  },

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.lang = this.$store.state.language.language;
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();

      const contentId = `CTA01-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    funcRoute(val) {
      //data form
      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      //dispatch save
      this.$store.dispatch('v3/saveContent', data);

      //next
      const nextPath = `/v3/${val[0]}/${val[1]}`;
      this.$router.push(nextPath);
    },
    commitPayloadData() {
      //for v4 planned ?
      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
        courseId: this.$store.state.necessary.learningCourse,
        template: this.v3Data.templateID,
        section: this.$store.state.v3.v3EnrollData.data.section,
        content: this.v3Data.content,
        type: this.v3Data.type,
        answering: [],
        progress: 100,
        score: 0,
        maxScore: 0,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const dataStack = this.$store.state.v4.v4DataStack;
      const currentCodeItem = this.v3Data.codeItem;
      const lastCodeItem = 'CTT-02';
      //check store
      if (dataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          //if currentCode === lastCodeItem dispatch
          this.$store.dispatch('v3/saveContent', dataStack);
          //clear payload after dispatch
          this.$store.commit('v4/clearPayloadStack');
        }
        //if not do nothing
      }
    },
  },
};
</script>
<style></style>
